// @ts-nocheck
import React, { useContext, useEffect } from 'react'
import Skeleton from '../components/Skeleton'
import { observer } from 'mobx-react'
import { StoreContext } from '../contexts/StoreContext'
import { sendEnhancedEcommerceEvent } from '../utils/analytics/analytics'
import { CONSTANTS, Page } from '../utils/constants'
import { useStores } from 'hooks/useStores'

const EEE = CONSTANTS.ANALYTICS.ENHANCED_ECOMMERCE_EVENTS

/**
 * Page to show summary for mobile view only.  In desktop view, the menu shows the cartSummary component on the side.
 *
 * @type {(function(*): *) & function(*): * extends IReactComponent<infer P> ? IWrappedComponent<P> : never}
 */
const Summary = observer(() => {
	const { cartStore } = useStores()
	const { store } = useContext(StoreContext)
	const rest = store.data
	const title = 'Order Summary'

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' })

		sendEnhancedEcommerceEvent(EEE.sendViewCartEvent, rest, cartStore.getAnalyticsFields())
	}, [])

	return (
		<Skeleton showBack title={title} showLogo showCustomMessage={false} showPaymentMessage={false} showHeader={false} page={Page.ORDER_SUMMARY} />
	)
})

export default Summary
